/* =============================================================
   JL FITNESS — Shopify theme behavior
   AJAX cart, variant picker, gallery, nav, reveals, preloader.
   ============================================================= */
(function () {
  'use strict';
  var JL = window.JL || {};
  var routes = JL.routes || {};

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var f = format || JL.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }
    var value = '';
    var match = f.match(placeholder);
    switch (match && match[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return f.replace(placeholder, value);
  }

  function req(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts))
      .then(function (r) { return r.json(); });
  }

  /* ---------- CART ---------- */
  function getCart() { return req(routes.cart + '.js'); }

  function updateCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('show', count > 0);
    });
  }

  function addToCart(id, quantity) {
    return req(routes.cartAdd, {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
    }).then(function (res) {
      if (res.status) { throw res; } // error object has .status/.description
      return getCart();
    });
  }

  function changeLine(key, quantity) {
    return req(routes.cartChange, {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  /* ---------- CART DRAWER ---------- */
  var drawer = document.getElementById('drawer');
  var drawerOv = document.getElementById('drawerOv');

  function openDrawer() { if (drawer) { drawer.classList.add('open'); drawerOv.classList.add('open'); document.body.classList.add('no-scroll'); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('open'); drawerOv.classList.remove('open'); document.body.classList.remove('no-scroll'); } }

  function renderDrawer(cart) {
    var body = document.getElementById('drawerBody');
    var foot = document.getElementById('drawerFoot');
    if (!body || !foot) return;
    updateCount(cart.item_count);

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="drawer__empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M6 7h12l1 13H5L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg><p>Your bag is empty.</p><p style="font-size:.82rem;margin-top:6px">Time to gear up.</p></div>';
      foot.innerHTML = '<a href="' + routes.cart + '" class="btn btn--primary btn--block">Start Shopping</a>';
      return;
    }

    body.innerHTML = cart.items.map(function (i) {
      var meta = i.product_has_only_default_variant ? '' : '<div class="cart-line__meta">' + i.options_with_values.map(function (o) { return o.value; }).join(' · ') + '</div>';
      var img = i.image ? '<img src="' + i.image + '" alt="' + esc(i.product_title) + '">' : '';
      return '<div class="cart-line">' + img +
        '<div><div class="cart-line__title">' + esc(i.product_title) + '</div>' + meta +
        '<div class="cart-line__price">' + formatMoney(i.final_price) + '</div>' +
        '<div class="qty"><button data-dline="dec" data-key="' + i.key + '" aria-label="Decrease">−</button><span>' + i.quantity + '</span><button data-dline="inc" data-key="' + i.key + '" aria-label="Increase">+</button></div></div>' +
        '<button class="cart-line__remove" data-dline="rm" data-key="' + i.key + '">Remove</button></div>';
    }).join('');

    var sub = cart.total_price;
    var note = '';
    if (JL.freeShip > 0) {
      note = sub >= JL.freeShip
        ? '🔥 You unlocked free shipping!'
        : 'Spend ' + formatMoney(JL.freeShip - sub) + ' more for free shipping';
    }
    foot.innerHTML =
      '<div class="drawer__row"><span style="color:var(--muted)">Subtotal</span><span style="font-family:var(--head);font-weight:600">' + formatMoney(sub) + '</span></div>' +
      '<div class="drawer__row total"><span>Total</span><span>' + formatMoney(sub) + '</span></div>' +
      '<a href="' + routes.cart + '" class="btn btn--ghost btn--block" style="margin-top:12px">View Bag</a>' +
      '<a href="/checkout" class="btn btn--primary btn--block" style="margin-top:8px">Checkout</a>' +
      (note ? '<p class="drawer__note">' + note + '</p>' : '');
  }

  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function refreshDrawer() { return getCart().then(renderDrawer); }

  if (drawerOv) drawerOv.addEventListener('click', closeDrawer);
  var drawerClose = document.getElementById('drawerClose');
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);

  // open drawer from header cart button (only if drawer enabled)
  var cartBtn = document.getElementById('cartBtn');
  if (cartBtn && JL.cartDrawer && drawer) {
    cartBtn.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  }

  // drawer line qty / remove (delegated)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dline]');
    if (!b) return;
    var key = b.dataset.key;
    var line = b.closest('.cart-line');
    var qtyEl = line ? line.querySelector('.qty span') : null;
    var cur = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    var next = b.dataset.dline === 'inc' ? cur + 1 : b.dataset.dline === 'dec' ? cur - 1 : 0;
    if (b.dataset.dline === 'rm') next = 0;
    b.closest('.drawer__body').classList.add('is-loading');
    changeLine(key, Math.max(0, next)).then(function (cart) {
      renderDrawer(cart);
      if (typeof window.updateCartPage === 'function') window.updateCartPage(cart);
    });
  });

  /* ---------- ADD TO CART ---------- */
  // quick add
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b || !b.dataset.variantId) return;
    e.preventDefault();
    var original = b.textContent;
    b.classList.add('is-loading'); b.disabled = true;
    addToCart(b.dataset.variantId, 1).then(function (cart) {
      renderDrawer(cart);
      b.classList.remove('is-loading'); b.disabled = false;
      b.textContent = 'Added ✓'; setTimeout(function () { b.textContent = original; }, 1200);
      if (JL.cartDrawer) openDrawer();
    }).catch(function (err) {
      b.classList.remove('is-loading'); b.disabled = false;
      b.textContent = (err && err.description) ? 'Unavailable' : original;
      setTimeout(function () { b.textContent = original; }, 1500);
    });
  });

  // product form
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var idInput = productForm.querySelector('[name="id"]');
      var qtyInput = productForm.querySelector('[name="quantity"]');
      var btn = document.getElementById('addBtn');
      if (!idInput || !idInput.value) return;
      var original = btn.innerHTML;
      btn.classList.add('is-loading'); btn.disabled = true;
      addToCart(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) : 1).then(function (cart) {
        renderDrawer(cart);
        btn.classList.remove('is-loading'); btn.disabled = false;
        btn.innerHTML = 'Added To Bag ✓'; setTimeout(function () { btn.innerHTML = original; }, 1400);
        if (JL.cartDrawer) openDrawer();
      }).catch(function (err) {
        btn.classList.remove('is-loading'); btn.disabled = false;
        btn.innerHTML = original;
        alert((err && err.description) || 'Sorry, this item could not be added.');
      });
    });
  }

  /* ---------- PDP VARIANT PICKER ---------- */
  var pdp = document.getElementById('ProductInfo');
  if (pdp) {
    var vScript = pdp.parentNode.querySelector('[data-product-variants]');
    var variants = vScript ? JSON.parse(vScript.textContent) : [];
    var priceEl = document.getElementById('pdpPrice');
    var addBtn = document.getElementById('addBtn');
    var idField = productForm ? productForm.querySelector('[name="id"]') : null;
    var mainImg = document.getElementById('pdpMain');

    function selectedOptions() {
      var opts = [];
      productForm.querySelectorAll('.js-option:checked').forEach(function (inp) {
        opts[parseInt(inp.dataset.position, 10) - 1] = inp.value;
      });
      return opts;
    }
    function matchVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, idx) { return opts[idx] == null || o === opts[idx]; });
      });
    }
    function updateVariant() {
      var opts = selectedOptions();
      var variant = matchVariant(opts);

      // active label styling + selected value labels
      productForm.querySelectorAll('.js-option').forEach(function (inp) {
        var label = productForm.querySelector('label[for="' + inp.id + '"]');
        if (label) label.classList.toggle('active', inp.checked);
        if (inp.checked) {
          var group = inp.closest('.opt-group');
          var sv = group && group.querySelector('[data-selected-value]');
          if (sv) sv.textContent = inp.value;
        }
      });

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.querySelector('[data-add-text]').textContent = 'Unavailable'; }
        return;
      }
      if (idField) idField.value = variant.id;

      // price
      if (priceEl) {
        var html = '<span class="price">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<span class="price--old">' + formatMoney(variant.compare_at_price) + '</span>';
          html += '<span class="badge badge--sale" style="margin-left:6px">Save ' + formatMoney(variant.compare_at_price - variant.price) + '</span>';
        }
        priceEl.innerHTML = html;
      }
      // button
      if (addBtn) {
        var txt = addBtn.querySelector('[data-add-text]');
        var bp = addBtn.querySelector('[data-buy-price]');
        if (variant.available) {
          addBtn.disabled = false;
          if (txt) txt.textContent = 'Add To Bag';
          if (bp) bp.textContent = formatMoney(variant.price);
        } else {
          addBtn.disabled = true;
          if (txt) txt.textContent = 'Sold Out';
          if (bp) bp.textContent = '';
        }
      }
      // image
      if (mainImg && variant.featured_image && variant.featured_image.src) {
        mainImg.src = variant.featured_image.src;
      }
      // url
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    productForm.querySelectorAll('.js-option').forEach(function (inp) {
      inp.addEventListener('change', updateVariant);
    });

    // thumbnails
    pdp.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) mainImg.src = t.dataset.src;
        pdp.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
  }

  /* ---------- QTY STEPPERS (PDP + cart) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var wrap = b.closest('.qty');
    var input = wrap ? wrap.querySelector('input') : null;
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val = b.dataset.qty === 'inc' ? val + 1 : Math.max(parseInt(input.min || '1', 10), val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- CART PAGE ---------- */
  var cartForm = document.getElementById('CartForm');
  if (cartForm) {
    window.updateCartPage = function (cart) {
      document.querySelectorAll('[data-cart-subtotal],[data-cart-total]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
      cart.items.forEach(function (i) {
        var row = cartForm.querySelector('[data-line-key="' + i.key + '"]');
        if (row) {
          var tot = row.querySelector('[data-line-total]');
          if (tot) tot.textContent = formatMoney(i.final_line_price);
          var input = row.querySelector('[data-line-input]');
          if (input) input.value = i.quantity;
        }
      });
      // remove rows no longer present
      cartForm.querySelectorAll('[data-line-key]').forEach(function (row) {
        if (!cart.items.some(function (i) { return i.key === row.dataset.lineKey; })) row.remove();
      });
      if (cart.item_count === 0) window.location.reload();
    };

    // qty change on cart line
    cartForm.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-input]');
      if (!input) return;
      var row = input.closest('[data-line-key]');
      cartForm.classList.add('is-loading');
      changeLine(row.dataset.lineKey, parseInt(input.value, 10) || 0).then(function (cart) {
        cartForm.classList.remove('is-loading');
        window.updateCartPage(cart);
        renderDrawer(cart);
      });
    });

    // remove link
    cartForm.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-line-remove]');
      if (!rm) return;
      e.preventDefault();
      var row = rm.closest('[data-line-key]');
      changeLine(row.dataset.lineKey, 0).then(function (cart) {
        window.updateCartPage(cart);
        renderDrawer(cart);
      });
    });
  }

  /* ---------- ADDRESS DELETE ---------- */
  document.addEventListener('click', function (e) {
    var d = e.target.closest('[data-address-delete]');
    if (!d) return;
    e.preventDefault();
    if (!window.confirm(d.dataset.confirm || 'Delete?')) return;
    var f = document.createElement('form');
    f.method = 'post'; f.action = d.dataset.addressDelete;
    f.innerHTML = '<input type="hidden" name="_method" value="delete">';
    document.body.appendChild(f); f.submit();
  });

  /* ---------- HEADER / NAV ---------- */
  var header = document.getElementById('header');
  if (header) window.addEventListener('scroll', function () { header.classList.toggle('scrolled', window.scrollY > 20); }, { passive: true });

  var burger = document.getElementById('burger');
  var mnav = document.getElementById('mnav');
  var mnavClose = document.getElementById('mnavClose');
  if (burger && mnav) burger.addEventListener('click', function () { mnav.classList.add('open'); document.body.classList.add('no-scroll'); });
  if (mnavClose) mnavClose.addEventListener('click', function () { mnav.classList.remove('open'); document.body.classList.remove('no-scroll'); });

  /* ---------- ACCORDIONS ---------- */
  document.addEventListener('click', function (e) {
    var h = e.target.closest('.acc__head');
    if (!h) return;
    var item = h.parentElement;
    item.classList.toggle('open');
    var body = item.querySelector('.acc__body');
    body.style.maxHeight = item.classList.contains('open') ? body.scrollHeight + 'px' : 0;
  });

  /* ---------- SCROLL REVEALS ---------- */
  function reveals() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!JL.reveals || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- PREDICTIVE SEARCH ---------- */
  var searchInput = document.getElementById('SearchInput');
  var searchResults = document.getElementById('SearchPredictive');
  if (searchInput && searchResults) {
    var t;
    searchInput.addEventListener('input', function () {
      clearTimeout(t);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      t = setTimeout(function () {
        var url = routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
        req(url).then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          searchResults.innerHTML = products.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="">' : '<span></span>';
            return '<a class="psearch__item" href="' + p.url + '">' + img + '<h4>' + esc(p.title) + '</h4><span class="price">' + p.price + '</span></a>';
          }).join('');
        });
      }, 200);
    });
    document.addEventListener('click', function (e) { if (!searchResults.contains(e.target) && e.target !== searchInput) searchResults.innerHTML = ''; });
  }

  /* ---------- PRELOADER ---------- */
  var PHX = 'M62.97,179.37c14.76-14.02,28.68-28.57,38.98-45.35-25.7,21.35-66.06,30.05-76.89,52.36,6.79-3.08,13.49-6.16,20.29-9.25-19.75,13.81-41.1,29.21-45.35,45.35,11.04-11.88,22.51-23.36,38.55-30.05-2.45,9.67-17.31,10.09-19.55,18.48,31.96-12.85,24.53-22.62,46.83-40.78-.96,3.07-1.91,6.15-2.87,9.24h0ZM37.38,211.65c-20.93-3.49-23.37,17-34.73,28.25,15.4,1.7,19.66-18.91,34.73-28.25h0ZM150.05,74.02c-.31-8.5,3.72-21.46,17-18.69,1.69-8.39-9.45-6.59-13.27-2.77-1.17-.42-2.34-.96-3.41-1.49-3.49.75-6.58,1.7-8.6,4.25-2.97-.64-5.95-1.28-9.03-1.91.75,4.88,4.57,6.48,7.97,8.17C110.23,96.75,40.89,42.9,46.08,0c-7.97,11.36-8.17,25.06-1.91,40.78-6.69-6.69-11.36-14.12-13.49-22.62-4.67,19.55,3.72,33.45,21.88,43.01-12-2.02-21.88-8.5-31.32-16.47,4.78,17.11,17.41,28.14,42.8,29.1-12.32,3.72-24.96,3.3-37.8-.21,9.24,11.26,24.74,17.74,55.43,12.85-7.12,5.95-16.14,9.35-25.7,11.88,10.3,4.46,22.73,5.52,44.71-8.7-7.64,10.41-17.09,16.25-26.97,20.93,10.52,2.65,22.3,1.8,41.31-19.02-3.51,5.32-7.01,10.73-10.51,16.04,7.22-4.68,14.44-9.45,21.66-14.13-2.88,5.63-5.74,11.27-8.61,16.89,5.42-4.57,10.72-9.24,16.04-13.91-.33,16.89-29.96,48.32-49.81,67.87-15.93,18.36-28.68,45.02-43.01,54.16,17.09-1.49,23.89-8.29,38.23-31.44,1.06-1.69,3.3-2.33,4.99-3.49-3.18,5.51-6.48,11.04-9.66,16.56,6.9-.75,12.1-5.52,16.03-13.49,3.61-12.32,8.39-23.36,14.55-33.03-2.87,7.54-5.1,14.98-4.68,22.3,1.7-3.29,3.4-6.59,5.1-9.88-1.49,13.7-4.99,21.35-9.14,26.97,29.32-17.63,3.83-40.89,32.07-68.92,12.54-11.15,38.13-33.03,21.77-50.01h0Z';
  function preloader() {
    if (!JL.onHome || !JL.preloader || sessionStorage.getItem('jl_seen')) return;
    sessionStorage.setItem('jl_seen', '1');
    var pre = document.createElement('div');
    pre.id = 'preloader';
    var embers = '';
    for (var i = 0; i < 14; i++) {
      var col = i % 3 === 0 ? '#00a5df' : i % 3 === 1 ? '#b02056' : '#ed1c24';
      embers += '<span style="left:' + (5 + Math.floor((i / 14) * 90)) + '%;animation-delay:' + (i * 0.15).toFixed(2) + 's;background:' + col + '"></span>';
    }
    pre.innerHTML =
      '<svg width="0" height="0"><defs><linearGradient id="preGrad" x1="0" y1="1" x2="1" y2="0"><stop offset="0" stop-color="#ed1c24"/><stop offset=".5" stop-color="#b02056"/><stop offset="1" stop-color="#00a5df"/></linearGradient></defs></svg>' +
      '<div class="pre__embers">' + embers + '</div>' +
      '<div style="display:flex;flex-direction:column;align-items:center">' +
      '<svg class="pre__phoenix" viewBox="0 0 167.22 240"><path d="' + PHX + '"/></svg>' +
      '<img class="pre__wordmark" src="' + (JL.logo || '') + '" alt="">' +
      '<div class="pre__bar"><i></i></div></div>';
    document.body.appendChild(pre);
    document.body.classList.add('no-scroll');
    setTimeout(function () {
      pre.classList.add('is-hidden');
      document.body.classList.remove('no-scroll');
      setTimeout(function () { pre.remove(); }, 700);
    }, 2100);
  }

  /* ---------- BOOT ---------- */
  function boot() {
    // initialise pre-opened accordions
    document.querySelectorAll('.acc__item.open .acc__body').forEach(function (b) { b.style.maxHeight = b.scrollHeight + 'px'; });
    refreshDrawer();
    preloader();
    reveals();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
